/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/layouts/charger_info'),
    meta: {
      title: 'ChargerInfo',
      keepAlive: false
    }
  },
  {
    path: '/check',
    name: 'check',
    component: () => import('@/views/layouts/charger_checked'),
    meta: {
      title: 'ChargerCheck',
      keepAlive: false
    }
  },
  // {
  //   path: '/pay',
  //   name: 'pay',
  //   component: () => import('@/views/layouts/charger_payment'),
  //   meta: {
  //     title: 'ChargerPayment',
  //     keepAlive: false
  //   }
  // },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/layouts/charger_success'),
    meta: {
      title: 'ChargingSuccess',
      keepAlive: false
    }
  },

  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('@/views/layouts/coupon_detail'),
    meta: {
      title: 'Coupon',
      keepAlive: false
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/layouts/charger_error'),
    meta: {
      title: 'ChargingError',
      keepAlive: false
    }
  },
  {
    path: '/process',
    name: 'process',
    component: () => import('@/views/layouts/charger_process'),
    meta: {
      title: 'ChargingProcess',
      keepAlive: false
    }
  },
  {
    path: '/amount',
    name: 'amount',
    component: () => import('@/views/stripe_new/stripe_select_amount.vue'),
    meta: {
      title: 'amount',
      keepAlive: false
    }
  },



  {
    path: '/stripe_test_checkout',
    name: 'stripe_test_checkout',
    component: () => import('@/views/stripe/stripe_test_payment_checkout.vue'),
    meta: {
      title: 'stripe_test_checkout',
      keepAlive: false
    }
  },

  {
    path: '/stripe_test_element',
    name: 'stripe_test_element',
    component: () => import('@/views/stripe/stripe_test_payment_element.vue'),
    meta: {
      title: 'stripe_test_element',
      keepAlive: false
    }
  },

  {
    path: '/stripe',
    name: 'stripe',
    component: () => import('@/views/stripe/stripe_request_payment_copy.vue'),
    meta: {
      title: 'StripePay',
      keepAlive: false
    }
  },

  {
    path: '/stripe_pay',
    name: 'stripe_pay',
    component: () => import('@/views/stripe_new/stripe_pay.vue'),
    meta: {
      title: 'stripe_pay',
      keepAlive: false
    }
  },
  {
    path: '/input_number',
    name: 'input_number',
    component: () => import('@/views/layouts/charger_input_number.vue'),
    meta: {
      title: 'InputNumber',
      keepAlive: false
    }
  },
  {
    path: '/stripe_connect',
    name: 'stripe_connect',
    component: () => import('@/views/stripe_new/stripe_connect.vue'),
    meta: {
      title: 'stripeConnect',
      keepAlive: false
    }
  },
  {
    path: '/receipt',
    name: 'receipt',
    component: () => import('@/views/layouts/charger_receipt.vue'),
    meta: {
      title: 'receipt',
      keepAlive: false
    }
  },
  {
    path: '/account_verified',
    name: 'account_verified',
    component: () => import('@/views/layouts/account_verified.vue'),
    meta: {
      title: 'AccountVerified',
      keepAlive: false
    }
  },
]

export const routerName = {
  check: 'check',
  // pay: 'pay',
  home: 'home',
  process: 'process',
  success: 'success',
  error: 'error',
  amount: 'amount',
  stripe: 'stripe',
  stripe_pay: 'stripe_pay',
  input_number: 'input_number',
  coupon: 'coupon',
  account_verified: 'account_verified'
}
